import { Button } from "components/atoms";
import { formatDate } from "date-fns";
import { ReactNode } from "react";
import { ToolbarProps } from "react-big-calendar";
import { useTranslation } from "react-i18next";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";
import "./CalendarTopbar.scss";

export interface ICalendarTopbar<
  TEvent extends object,
  TResource extends object
> extends ToolbarProps<TEvent, TResource> {
  topbarHeader?: ReactNode;
}

const CalendarTopbar = <TEvent extends object, TResource extends object>({
  date,
  label,
  localizer,
  onNavigate,
  onView,
  view,
  views,
  children,
  topbarHeader,
}: ICalendarTopbar<TEvent, TResource>) => {
  const { t } = useTranslation();
  return (
    <div className="magellan-calendar-topbar">
      <div className="magellan-calendar-topbar-header">{topbarHeader}</div>
      <div className="magellan-calendar-topbar-buttons">
        {t(`enum.MONTH.${formatDate(date, "MMMM")}`)} {formatDate(date, "yyyy")}
        <div>
          <Button isClear onlyIcon onClick={() => onNavigate("TODAY")}>
            <Button.Text text={t("button.today")} />
          </Button>
          <Button onlyIcon isClear onClick={() => onNavigate("PREV")}>
            <Button.Icon icon={<TbChevronLeft />} />
          </Button>
          <Button onlyIcon isClear onClick={() => onNavigate("NEXT")}>
            <Button.Icon icon={<TbChevronRight />} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarTopbar;
